// extracted by mini-css-extract-plugin
export default {"triple-card-buttons":"TripleCardButtons_triple-card-buttons__VoGfE","button-wrapper":"TripleCardButtons_button-wrapper__1Hm9U"};